export default __webpack_public_path__ + "static/media/discounts-monday-image.df3e40aa.svg";